var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customer-uploader"},[_c('div',{staticClass:"select-file",on:{"click":function($event){return _vm.handleGetFile()}}},[_vm._t("default")],2),_c('input',{ref:"file",staticClass:"file-input",attrs:{"type":"file"},on:{"change":function($event){return _vm.handleFileUpload()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }